import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface GAIAProductListControlsStyles {
    container?: InjectableCss;
    listControlContainer?: InjectableCss;
    countContainer?: InjectableCss;
    sortSelectContainer?: InjectableCss;
    viewSelectContainer?: InjectableCss;
    paginationContainer?: InjectableCss;
}

export const styles: GAIAProductListControlsStyles = {
    container: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #f0f4f3;
            padding: 0.5rem;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            flex-direction: column;
                            align-items: flex-start;
                        `,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    listControlContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #f0f4f3;
            width: 100%;
            /* ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            margin-bottom: 0.5rem;
                            width: 100%;
                        `,
                        null,
                    ],
                    "max",
                )} */
        `,
    },
    countContainer: {
        css: css`
            /* width: 25%; */
            > div[class^="Wrapper"] > div[class^="sc"] {
                margin-top: 0px;
            }
        `,
    },
    sortSelectContainer: {
        css: css`
            div[class^="FormFieldStyle"] {
                div[class^="FormInputWrapper"] {
                    flex: 1;
                }

                width: 100%;
                display: flex;
                align-items: center;
                label {
                    padding-top: 0px;
                }
            }
        `,
    },
    viewSelectContainer: {
        css: css`
            width: 90px;
            > div[class^="Wrapper"] > div[class^="sc"] {
                float: none;
                justify-content: space-around;
                button {
                    margin-right: 0px;
                }
            }
        `,
    },
    paginationContainer: {
        css: css`
            div[class^="PaginationStyle"] {
                background-color: transparent;
                margin: 0px;
                padding: 0px;

                span[class^="PerPageSelect"] {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    justify-content: flex-start;
                                    label {
                                        text-align: left;
                                    }
                                `,
                                null,
                            ],
                            "max",
                        )}
                }

                nav {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    justify-content: flex-start;
                                `,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
};

const GAIAProductListControls: FC<Props> = ({ id, view }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.listControlContainer}>
                <StyledWrapper {...styles.countContainer}>
                    <Zone contentId={id} zoneName="CountContainer" />
                </StyledWrapper>
                <StyledWrapper {...styles.sortSelectContainer}>
                    <Zone contentId={id} zoneName="SortSelect" />
                </StyledWrapper>
                {/* <Hidden below="lg">
                    <StyledWrapper {...styles.viewSelectContainer}>
                        <Zone contentId={id} zoneName="ViewSelect" />
                    </StyledWrapper>
                </Hidden> */}
            </StyledWrapper>
            {/* <StyledWrapper {...styles.paginationContainer}>
                <Zone contentId={id} zoneName="Pagination" />
            </StyledWrapper> */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GAIAProductListControls),
    definition: {
        group: "Product List",
        displayName: "GAIA Product List Controls",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
